export type BodyBlockType = 'heading' | 'paragraph';

export interface BodyBlock {
    type: BodyBlockType;
    key: string;
}

export interface HelpArticle {
    slug: string;
    category: string;
    titleKey: string;
    descriptionKey: string;
    bodyBlocks: BodyBlock[];
}

export const HELP_ARTICLES: HelpArticle[] = [
    {
        slug: 'multi-organization',
        category: 'organizations',
        titleKey: 'help_article_multi_org_title',
        descriptionKey: 'help_article_multi_org_desc',
        bodyBlocks: [
            {type: 'heading',   key: 'help_article_multi_org_h1'},
            {type: 'paragraph', key: 'help_article_multi_org_p1'},
            {type: 'paragraph', key: 'help_article_multi_org_p2'},
            {type: 'heading',   key: 'help_article_multi_org_h2'},
            {type: 'paragraph', key: 'help_article_multi_org_p3'},
            {type: 'paragraph', key: 'help_article_multi_org_p4'},
            {type: 'heading',   key: 'help_article_multi_org_h3'},
            {type: 'paragraph', key: 'help_article_multi_org_p5'},
            {type: 'heading',   key: 'help_article_multi_org_h4'},
            {type: 'paragraph', key: 'help_article_multi_org_p6'},
            {type: 'paragraph', key: 'help_article_multi_org_p7'},
        ],
    },
    {
        slug: 'switching-organizations',
        category: 'organizations',
        titleKey: 'help_article_switching_title',
        descriptionKey: 'help_article_switching_desc',
        bodyBlocks: [
            {type: 'heading',   key: 'help_article_switching_h1'},
            {type: 'paragraph', key: 'help_article_switching_p1'},
            {type: 'paragraph', key: 'help_article_switching_p2'},
            {type: 'heading',   key: 'help_article_switching_h2'},
            {type: 'paragraph', key: 'help_article_switching_p3'},
            {type: 'heading',   key: 'help_article_switching_h3'},
            {type: 'paragraph', key: 'help_article_switching_p4'},
        ],
    },
    {
        slug: 'invitations-and-portal-access',
        category: 'access',
        titleKey: 'help_article_invitations_title',
        descriptionKey: 'help_article_invitations_desc',
        bodyBlocks: [
            {type: 'heading',   key: 'help_article_invitations_h1'},
            {type: 'paragraph', key: 'help_article_invitations_p1'},
            {type: 'paragraph', key: 'help_article_invitations_p2'},
            {type: 'heading',   key: 'help_article_invitations_h2'},
            {type: 'paragraph', key: 'help_article_invitations_p3'},
            {type: 'paragraph', key: 'help_article_invitations_p4'},
            {type: 'heading',   key: 'help_article_invitations_h3'},
            {type: 'paragraph', key: 'help_article_invitations_p5'},
            {type: 'heading',   key: 'help_article_invitations_h4'},
            {type: 'paragraph', key: 'help_article_invitations_p6'},
            {type: 'heading',   key: 'help_article_invitations_h5'},
            {type: 'paragraph', key: 'help_article_invitations_p7'},
            {type: 'paragraph', key: 'help_article_invitations_p8'},
        ],
    },
    {
        slug: 'troubleshooting-access',
        category: 'access',
        titleKey: 'help_article_troubleshooting_title',
        descriptionKey: 'help_article_troubleshooting_desc',
        bodyBlocks: [
            {type: 'heading',   key: 'help_article_troubleshooting_h1'},
            {type: 'paragraph', key: 'help_article_troubleshooting_p1'},
            {type: 'heading',   key: 'help_article_troubleshooting_h2'},
            {type: 'paragraph', key: 'help_article_troubleshooting_p2'},
            {type: 'heading',   key: 'help_article_troubleshooting_h3'},
            {type: 'paragraph', key: 'help_article_troubleshooting_p3'},
            {type: 'heading',   key: 'help_article_troubleshooting_h4'},
            {type: 'paragraph', key: 'help_article_troubleshooting_p4'},
            {type: 'heading',   key: 'help_article_troubleshooting_h5'},
            {type: 'paragraph', key: 'help_article_troubleshooting_p5'},
            {type: 'heading',   key: 'help_article_troubleshooting_h6'},
            {type: 'paragraph', key: 'help_article_troubleshooting_p6'},
        ],
    },
    {
        slug: 'my-profile',
        category: 'account',
        titleKey: 'help_article_profile_title',
        descriptionKey: 'help_article_profile_desc',
        bodyBlocks: [
            {type: 'heading',   key: 'help_article_profile_h1'},
            {type: 'paragraph', key: 'help_article_profile_p1'},
            {type: 'heading',   key: 'help_article_profile_h2'},
            {type: 'paragraph', key: 'help_article_profile_p2'},
            {type: 'heading',   key: 'help_article_profile_h3'},
            {type: 'paragraph', key: 'help_article_profile_p3'},
            {type: 'heading',   key: 'help_article_profile_h4'},
            {type: 'paragraph', key: 'help_article_profile_p4'},
        ],
    },
    {
        slug: 'notifications-overview',
        category: 'notifications',
        titleKey: 'help_article_notif_overview_title',
        descriptionKey: 'help_article_notif_overview_desc',
        bodyBlocks: [
            {type: 'heading',   key: 'help_article_notif_overview_h1'},
            {type: 'paragraph', key: 'help_article_notif_overview_p1'},
            {type: 'heading',   key: 'help_article_notif_overview_h2'},
            {type: 'paragraph', key: 'help_article_notif_overview_p2'},
            {type: 'paragraph', key: 'help_article_notif_overview_p3'},
            {type: 'heading',   key: 'help_article_notif_overview_h3'},
            {type: 'paragraph', key: 'help_article_notif_overview_p4'},
        ],
    },
    {
        slug: 'messaging-settings',
        category: 'notifications',
        titleKey: 'help_article_messaging_title',
        descriptionKey: 'help_article_messaging_desc',
        bodyBlocks: [
            {type: 'heading',   key: 'help_article_messaging_h1'},
            {type: 'paragraph', key: 'help_article_messaging_p1'},
            {type: 'heading',   key: 'help_article_messaging_h2'},
            {type: 'paragraph', key: 'help_article_messaging_p2'},
            {type: 'heading',   key: 'help_article_messaging_h3'},
            {type: 'paragraph', key: 'help_article_messaging_p3'},
            {type: 'heading',   key: 'help_article_messaging_h4'},
            {type: 'paragraph', key: 'help_article_messaging_p4'},
            {type: 'heading',   key: 'help_article_messaging_h5'},
            {type: 'paragraph', key: 'help_article_messaging_p5'},
            {type: 'heading',   key: 'help_article_messaging_h6'},
            {type: 'paragraph', key: 'help_article_messaging_p6'},
            {type: 'heading',   key: 'help_article_messaging_h7'},
            {type: 'paragraph', key: 'help_article_messaging_p7'},
            {type: 'heading',   key: 'help_article_messaging_h8'},
            {type: 'paragraph', key: 'help_article_messaging_p8'},
            {type: 'heading',   key: 'help_article_messaging_h9'},
            {type: 'paragraph', key: 'help_article_messaging_p9'},
        ],
    },
    {
        slug: 'patient-import',
        category: 'patients',
        titleKey: 'help_article_patient_import_title',
        descriptionKey: 'help_article_patient_import_desc',
        bodyBlocks: [
            {type: 'heading',   key: 'help_article_patient_import_h1'},
            {type: 'paragraph', key: 'help_article_patient_import_p1'},
            {type: 'paragraph', key: 'help_article_patient_import_p2'},
            {type: 'heading',   key: 'help_article_patient_import_h2'},
            {type: 'paragraph', key: 'help_article_patient_import_p3'},
            {type: 'paragraph', key: 'help_article_patient_import_p4'},
            {type: 'heading',   key: 'help_article_patient_import_h3'},
            {type: 'paragraph', key: 'help_article_patient_import_p5'},
            {type: 'paragraph', key: 'help_article_patient_import_p6'},
            {type: 'heading',   key: 'help_article_patient_import_h4'},
            {type: 'paragraph', key: 'help_article_patient_import_p7'},
            {type: 'paragraph', key: 'help_article_patient_import_p8'},
            {type: 'heading',   key: 'help_article_patient_import_h5'},
            {type: 'paragraph', key: 'help_article_patient_import_p9'},
            {type: 'paragraph', key: 'help_article_patient_import_p10'},
            {type: 'heading',   key: 'help_article_patient_import_h6'},
            {type: 'paragraph', key: 'help_article_patient_import_p11'},
            {type: 'paragraph', key: 'help_article_patient_import_p12'},
        ],
    },
];

export const HELP_CATEGORIES = ['organizations', 'access', 'account', 'notifications', 'patients'] as const;

export const findArticleBySlug = (slug: string): HelpArticle | undefined =>
    HELP_ARTICLES.find(a => a.slug === slug);
